import Button from 'components/ui/Button';
import Drawer from 'components/Drawer';
import Text from 'components/ui/Text';
import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';

type LeaveConfirmationProps = {
  isOpen?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const LeaveConfirmation: FC<LeaveConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const translation = useTranslation();

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      position="center"
      transition="fade"
      backdropClassName="bg-black/30"
      className="z-10"
    >
      <div className="bg-white rounded-xl p-8">
        <Text bold size="large" elementType="div" className="mb-4">
          {translation('room.leaveConfirmation.title')}
        </Text>

        <Text elementType="p" className="mb-8">
          {translation('room.leaveConfirmation.text')}
        </Text>

        <div className="flex items-center gap-6">
          <Button onClick={onClose} style="outline">
            {translation('room.leaveConfirmation.cancel')}
          </Button>
          <Button onClick={onConfirm}>
            {translation('room.leaveConfirmation.confirm')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default LeaveConfirmation;
